<style scoped lang="scss">
    .bottom {
        justify-content: flex-end;
    }

    textarea {
        border: 0px none;
        outline: none;
        width: 100%;
        height: 60px;
        resize: none;
    }
</style>
<template>
    <div>
        <div class="pl15 pr15 pt10 pb10 flex bb aic">
            <ol class="btns flex aic pointer">
                <li v-for="(val,key) in btns" class="flex flex0 mr5 aic">
                    <img :src="val" alt="" class="flex0">
                    <span class="flex0 color_666 fs14 ml5">{{key}}</span>
                </li>
            </ol>
            <slot name="btns"></slot>
        </div>
        <div class="send bg_fff pl15 pr15 pt15 pb15">
            <textarea placeholder="请说点什么吧"></textarea>
            <div class="flex bottom">
                <p class="app_btn_main_mini">发送</p>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "send-msg-box",
    data() {
      return {
        btns: {
          '图片': require('../../assets/icon/sendmsgbox/图片.png'),
          '文章': require('../../assets/icon/sendmsgbox/文章.png'),
          '常用语': require('../../assets/icon/sendmsgbox/常用语.png'),
        }
      }
    },
  }
</script>
